module.exports = __webpack_public_path__ + "img/Airbnb-Equipment-Accessories.1bde541b.jpg";